import { CircleCheckBigIcon, DotIcon } from "lucide-react";
import type { ReactNode } from "react";

export function DotList({
  items,
  className = "",
  icon = <DotIcon className="h-3 w-3 text-slate-300" />,
}: {
  items: string[];
  className?: string;
  icon?: ReactNode;
}) {
  return (
    <ul className={`mt-2 space-y-1 text-sm text-slate-600 ${className}`}>
      {items.map((t) => (
        <li key={t} className="flex items-start gap-2">
          <span className="mt-[3px]">{icon}</span>
          <span className="leading-[1.35]">{t}</span>
        </li>
      ))}
    </ul>
  );
}

export function CheckList({
  items,
  className = "",
  icon = <CircleCheckBigIcon className="h-3 w-3" />,
}: {
  items: string[];
  className?: string;
  icon?: ReactNode;
}) {
  return (
    <ul className={`mt-2 space-y-1 text-xs text-slate-600 ${className}`}>
      {items.map((t) => (
        <li key={t} className="flex items-start gap-2">
          <span className="mt-[1px] text-emerald-600">{icon}</span>
          <span className="leading-[1.35]">{t}</span>
        </li>
      ))}
    </ul>
  );
}
